/* Defer a Swiper init until its container nears the viewport (300px margin).
   Falls back to immediate init when IntersectionObserver is unavailable. */
function initNearView(el, init) {
  if (!el) return;
  if (!('IntersectionObserver' in window)) { init(); return; }
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { io.disconnect(); init(); }
  }, { rootMargin: '300px 0px' });
  io.observe(el);
}


/* Stop a continuous-autoplay Swiper while it is off screen — it otherwise
   animates (and burns main-thread) for the whole page lifetime. */
function pauseOffscreen(el, sw) {
  if (!el || !sw || !sw.autoplay || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting) { sw.autoplay.start(); }
    else { sw.autoplay.stop(); }
  }, { rootMargin: '100px 0px' });
  io.observe(el);
}

jQuery(document).ready(function () {


  var productOOS = false;


  $('.shopify-section--main-1225-google-reviews').insertAfter('.section-onefit-pay');

  initNearView(document.querySelector('.swiper-index-2026-ups'), function () {
  new Swiper('.swiper-index-2026-ups', {
    slidesPerView: 1.10,
    spaceBetween: 21,
    autoHeight: false,
    loop: true,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,  // keeps playing after swipe
      pauseOnMouseEnter: false,      // keeps playing on hover
    },

    breakpoints: {
      768: {
        slidesPerView: 4.2
      }
    }
  });
  });

  initNearView(document.querySelector('.swiper-index-2026-slides'), function () {
  new Swiper('.swiper-index-2026-slides', {
    slidesPerView: 1.6,
    spaceBetween: 15,
    autoHeight: false,
    autoplay: false,  

    breakpoints: {
      768: {
        slidesPerView: 5,
        spaceBetween: 32,
      }
    }

  });
  });



  $('.index-2026-tabs [data-product]').on('click', function () {

      const product = $(this).data('product');


      // toggle active tab
      $('.index-2026-tabs [data-product]').removeClass('active');
      $('.index-2026-tabs [data-product="'+product+'"]').addClass('active');

      // toggle matching slide
      $('.swiper-index-2026-slides[data-product]').removeClass('active');
      $('.swiper-index-2026-slides[data-product="' + product + '"]').addClass('active');

      
      $('.swiper-index-2026-vertical-carousel[data-product]').removeClass('active');
      $('.swiper-index-2026-vertical-carousel[data-product="' + product + '"]').addClass('active');

      $('.onefit-section-ingredients-cta[data-product]').removeClass('active');
      $('.onefit-section-ingredients-cta[data-product="' + product + '"]').addClass('active');

      $('.swiper-index-2026-tabs[data-product]').removeClass('active');
      $('.swiper-index-2026-tabs[data-product="' + product + '"]').addClass('active');

  });

  $(window).on('load',function(){
    if ($(window).width() >= 1040){
      $('#onefit-all-gallery').stickySidebar({
          topSpacing: 110,
          bottomSpacing: 60
      });
    }
  });

  
  $(".main-gallery video[autoplay]").each(function() {
    var video = this;
    var playPromise = video.play();

    if (playPromise !== undefined) {
      playPromise.catch(function() {
        // Autoplay blocked → play on first tap
        $(document).one("touchstart", function() {
          video.play();
        });
      });
    }
  });

  

  $(window).on("scroll", function() {
    var checkoutBtn = $("#fon-checkout-button");

    if (checkoutBtn.length) {
      var scrollTop = $(window).scrollTop();
      var checkoutOffset = checkoutBtn.offset().top;

      if (scrollTop > checkoutOffset) {
        $("body").addClass("scrolled-add-to-cart");
      } else {
        $("body").removeClass("scrolled-add-to-cart");
      }
    }
  });


  let mainSwiper;
let thumbsSwiper;
// Run on load
initSwiper();
function initSwiper() {

  const thumbsSwiper = new Swiper(".swiper-main-gallery-thumbnails", {
  direction: "vertical", // default direction
  spaceBetween: 8,
  slidesPerView: 'auto',
  freeMode: true,
  watchSlidesProgress: true,
  slideToClickedSlide: true,
  loop: false,
  breakpoints: {
    // when window width is <= 768px (mobile)
    0: {
      direction: "horizontal", 
      slidesPerView: 5.5
    },
    // when window width is > 768px (desktop)
    769: {
      direction: "vertical",
    },
  },
});
    // Initialize the main swiper
    mainSwiper = new Swiper(".main-gallery", {
      loop: false,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      thumbs: {
        swiper: thumbsSwiper, // connect to thumbnails
      },
    });


    thumbsSwiper.on('click', function (swiper, e) {
      const clickedIndex = swiper.clickedIndex;
      if (clickedIndex !== undefined) {
        // scroll so that clicked slide is always visible
        thumbsSwiper.slideTo(clickedIndex - 1); // adjust "-2" to show some slides before
      }
    });
  
}








 // Flavour options
 

  $(document).on('click','#fon-oos-button',function(){

      var variantID = $('.fon-flavour.active').attr('data-variant-id');
      // $.magnificPopup.open({
      //   items: {
      //     src: '.klaviyo-oos-' + variantID // This is the ID of the hidden div
      //   },
      //   type: 'inline'
      // });

      // Temporary
      // showOutOfStockPopup(variantID);
      showOutOfStockPopup(52881590223032);
      

  });


  var flavourClick  = 0;
  // $(".flavour-options > div").not(".fon-flavour-oos").on("click", function () {
  $(".flavour-options > div").on("click", function () {

    
    if ($(this).hasClass('fon-flavour-oos') || $(this).hasClass('fon-flavour-force-sold-out')){
      $('body').addClass('selected-variant-oos');
      $('#fon-oos-button').addClass('active');
    }else{
      $('body').removeClass('selected-variant-oos');
      $('#fon-oos-button').removeClass('active');
    }

    flavourClick++;

    // Reset siblings
    $(this).siblings()
      .removeClass("active");

    // Activate this one
    $(this)
    .addClass("active")
    .find(".flavour-color")
    .css({
      "background-color": $(this).data("color"),
      "border-color": $(this).data("color")
    });
    
    // if (isLightColor($(this).data("color"))) {
    //   $(this).addClass("light");
    // }

    var selectedVariantText = $('.fon-flavour.active').attr('data-text');

    // selectedVariantText = '<div class=&quot;metafield-rich_text_field&quot;><p>Taste is personal. Hate it? Instant swap.</p></div>';
    $('.flavour-label').html(selectedVariantText);


    // Product Gallery
    if (flavourClick > 1){
      updateImage();
    }
    

    checkSelections();
  });


  function updateImage(){
      var selectedVariantID = $('.fon-flavour.active').attr('data-variant-id');
      var selectedVariantImage = $('.fon-flavour.active').attr('data-variant-image');
      var selectedVariantVideo = $('.fon-flavour.active').attr('data-variant-video');
      var selectedVariantImageMobile = $('.fon-flavour.active').attr('data-variant-image-mobile');
      
      var size = parseInt($('[data-size]').data('size'));


      // Cache the active element
      var $active = $('.fon-flavour.active');

   
      for (var i = 0; i < size; i++) {
        var attrName = 'data-gallery-image-' + i;
        var imageURL = $active.attr(attrName);

        console.log(attrName + ' ' + imageURL);

        if (imageURL) {
          // Update thumbnail image
          $('.thumb-index-' + i).find('img').attr('src', imageURL);

          // Update main swiper slide image
          $('.swiper-slide-fon-index-' + i).find('img').attr('src', imageURL);
        }
      }
      

      

    }

   

  var selectedOrFirstAvailableVariantID = $('.flavour-options').attr('data-active-variant');
  $(`.fon-flavour[data-variant-id="${selectedOrFirstAvailableVariantID}"]`).click();
  checkSelections();

 

  // Packaging options
  $("#packaging-options .fon-packaging").on("click", function () {


    var currentFlavour = $('.fon-flavour.active').data('variant-title');

    

    var packagingName = $(this).data('packaging');
    if (packagingName == 'sachets'){
      $('.per-serve-label').html('Sachets');
    }else{
      $('.per-serve-label').html('Scoops');
    }


    $("#packaging-options .fon-packaging").removeClass("active");
    $(this).addClass("active");

    // Hide all flavour option groups
    $(".flavour-options").removeClass("active").find("div").removeClass("active").css("background-color", "inherit")           // reset parent div

        // Show the matching flavour options
        const packaging = $(this).data("packaging");
        $(`#flavour-options-${packaging}`).addClass("active");


        if ($(`#flavour-options-${packaging}`).find('.fon-flavour[data-variant-title="'+currentFlavour+'"]').length){
            $(`#flavour-options-${packaging}`).find('.fon-flavour[data-variant-title="'+currentFlavour+'"]').trigger('click');
        }else{
            checkSelections();
        }
        

    });

  // Quantity picker
  $("#quantity-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    var label = $(this).data("label");
    $('.quantity-options-label p').html(label);
    checkSelections();
  });

  // Paying options
  $("#paying-options > div").on("click", function () {
    $(this).siblings().removeClass("active");
    $(this).addClass("active");
    checkSelections();
  });


  checkSelections();

  function checkSelections(){
      checkVariantOption();
      checkPrices();
      checkCheckout();
      checkAfterPay();

       if ($('.fon-packaging.active').data('packaging') == 'sachets'){
          $('.dynamic-try-one').html('Try One-Time Box Of 20');
        }else{
          $('.dynamic-try-one').html('Try Once - 20 Serve Pouch');
        }

      // Floating add to cart
      var originalPrice = $('#fon-subscription-options').find('.original-price').html();
      var salePrice = $('#fon-subscription-options').find('.sale-price').html();

      $('.onefit-all-subscribe-save .save-new-price .price').html(salePrice);
      $('.onefit-all-subscribe-save .save-old-price .price').html(originalPrice);
      $('.onefit-all-onetime-only .save-new-price .price').html(originalPrice);

      if ($('#fon-subscription-options').hasClass('active')){
        $('.onefit-all-subscribe-save').show();
        $('.onefit-all-onetime-only').hide();
      }else{
        $('.onefit-all-subscribe-save').hide();
        $('.onefit-all-onetime-only').show();
      }


      $('.dynamic-selected-flavour').html($('.fon-flavour.active').attr('data-variant-title'));
      $('.dynamic-selected-quantity').html($('.fon-quantity-picker.active').find('p').html());
      

      if ($('div#fon-subscription-options').hasClass('active')){
        $('.dynamic-selected-price').html('Subscription');
      }else{
        $('.dynamic-selected-price').html('One-time');
      }

  }

  function checkAfterPay(){

      var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');
      if (activePaymentPlan == 'subscription'){
        $('.afterpay-text').hide();
      }else{
        $('.afterpay-text').show();
      }

      // if (activePaymentPlan == 'onetime'){
      //   $('#fon-checkout-button').html('Buy One-Time');
        
      // }else{

        if (activePaymentPlan == 'subscription-90d'){
          $('#fon-checkout-button').html('Get The Complete System - Save 33%');
        }else if (activePaymentPlan == 'subscription-365d'){
          $('#fon-checkout-button').html('Get The Complete System - Save 40%');
        }else{
          $('#fon-checkout-button').html('Get The Complete System - Save 29%');
        }
        
      // }

  }
  function checkCheckout(){
    var checkoutButton = $('#fon-checkout-button');
    if ($('.fon-subscription-option.active').length){
      checkoutButton.prop('disabled',false);
    }else{
      checkoutButton.prop('disabled',true);
    }
  }

  $(document).on('click', '#fon-checkout-button, .btn-floating-add-to-cart', function () {



    // // March 31, 2026 OneLife OOS
    // if (productOOS){
    //   showOutOfStockPopup(52881590223032); // OneLife
    //   return;
    // }



    var $btn = $(this);

    // Collect selected values
    var quantityElement = $('.fon-quantity-picker.active');
    var qty = parseInt(quantityElement.attr('data-qty'));

    var selectedVariant = $('.flavour-options > div.active');
    var variantID = selectedVariant.attr('data-variant-id');
    var variantSellingPlanID = selectedVariant.attr('data-selling-plan-id');

    var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');

    
    switch (activePaymentPlan){
      case 'onetime':
        // Prepare data for Shopify AJAX API
        var formData = {
          items: [
            {
              id: variantID,
              quantity: qty
            }
          ]
        };

        formData.items[0].properties = {
          _order_from : 'comprehensive-main'
        };


        if (activePaymentPlan === 'subscription' && variantSellingPlanID) {
          formData.items[0].selling_plan = variantSellingPlanID;
        }

        // Disable button & show loading state
        var originalText = $btn.text();
        $btn.text('Adding to cart...').prop('disabled', true);

        // AJAX add to cart
        /* Open the drawer NOW, not in the success callback. It renders the cart it
           already has, so it appears immediately and fills in when the add lands.
           Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
        if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: JSON.stringify(formData),
          dataType: 'json',
          contentType: 'application/json',
          success: function (response) {
            console.log('Added to cart:', response);

            // ✅ Update and open cart drawer
            if (typeof FonCartDrawer !== 'undefined') {
              FonCartDrawer.updateCartDrawer(response);
              FonCartDrawer.openCartDrawer();
            }

            // ✅ Revert button
            $btn.text(originalText).prop('disabled', false);
          },
          error: function (xhr, status, error) {
            console.error('Error:', error);

            // ❌ Revert button
            $btn.text(originalText).prop('disabled', false);
            alert('Something went wrong. Please try again.');
          }
        });
      break;
      case 'subscription-60d':
        
        checkout60d($(this),selectedVariant);
      break;
      case 'subscription-90d':
        checkout90d($(this),selectedVariant);
      break;

      case 'subscription-365d':
        checkout365d($(this),selectedVariant);
      break;
      case 'subscription-30d':
        checkout30d($(this),selectedVariant);
      break;

    }

    
  });

  function checkout90d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-90d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-90d-variant-selling-plan-id');

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 5,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
            '_BUNDLE' : 'comprehensive_90d',
            '_bundle_group_id' : 'comprehensive_90d_' + specialOfferVariantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 1,
            "_bundle_group_product_multiplier" : 5,
            '_offer' : 'comprehensive_90d_' + specialOfferVariantID,
            '_offer_product_type' : 'primary',
            '_order_from' : 'comprehensive-challenger'
          }
        }
      ]
    };

    // OneLife
    var onelifeVariantID = selectedVariant.attr('data-90d-onelife-variant-id');
    var onelifeVariantSellingPlanID = selectedVariant.attr('data-90d-onelife-variant-selling-plan-id');

    formData.items.push({
      id: onelifeVariantID,
      quantity: 3,
      selling_plan: onelifeVariantSellingPlanID,
      properties : {
        '_BUNDLE' : 'comprehensive_90d',
        '_bundle_group_id' : 'comprehensive_90d_' + specialOfferVariantID,
        "_bundle_group_product" : true,
        "_bundle_group_product_row" : 2,
        "_bundle_group_product_multiplier" : 3,
        '_offer' : 'comprehensive_90d_' + specialOfferVariantID,
        '_offer_product_type' : 'primary',
        '_order_from' : 'comprehensive-challenger'
      }
    });

    if (false && !bottleOOS) /*free gift off*/ {
      formData.items.push({
        id: 53491544391864, // Free bottle variant ID
        quantity: 2,
        properties : {
          '_offer' : 'comprehensive_90d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // 2026-05-21
    if (false && !frotherOOS) /*free gift off*/ {
      formData.items.push({
        id: 52887363551416, // Free frother variant ID
        quantity: 1,
        properties : {
          '_offer' : 'comprehensive_90d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // Disable button & show loading
    var originalText = $btn.text();
     $btn.text('Preparing your stack...').prop('disabled', true);

    // 1️⃣ Clear cart first
    // $.ajax({
    //   type: 'POST',
    //   url: '/cart/clear.js',
    //   success: function () {

    //     // 2️⃣ Add new items
    //     $.ajax({
    //       type: 'POST',
    //       url: '/cart/add.js',
    //       data: JSON.stringify(formData),
    //       dataType: 'json',
    //       contentType: 'application/json',
    //       success: function () {
    //         setTimeout(function(){
    //           $btn.text(originalText).prop('disabled', false);
    //         },2000);
    //         // 3️⃣ Redirect to checkout
    //         window.location.href = '/checkout';
    //       },
    //       error: function () {
    //         resetButton();
    //         alert('Could not add item to cart. Please try again.');
    //       }
    //     });

    //   },
    //   error: function () {
    //     resetButton();
    //     alert('Could not clear cart. Please try again.');
    //   }
    // });

         // 1️⃣ Check cart first
          // 2️⃣ Add to cart
      /* Open the drawer NOW, not in the success callback. It renders the cart it
         already has, so it appears immediately and fills in when the add lands.
         Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
      if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function (addResponse) {
          setTimeout(function(){
            $btn.text(originalText).prop('disabled', false);
          }, 2000);

          // Always open the drawer to show the bundle (was: redirect to checkout when cart was empty)
          if (typeof FonCartDrawer !== 'undefined') {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer(addResponse);
          }
        },
        error: function () {
          resetButton();
          alert('Could not add item to cart. Please try again.');
        }
      });
    

    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }


  function checkout365d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-365d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-365d-variant-selling-plan-id');

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 19,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
            '_BUNDLE' : 'comprehensive_365d',
            '_bundle_group_id' : 'comprehensive_365d_' + specialOfferVariantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 1,
            "_bundle_group_product_multiplier" : 19,
            '_offer' : 'comprehensive_365d_' + specialOfferVariantID,
            '_offer_product_type' : 'primary',
            '_order_from' : 'comprehensive-challenger'
          }
        }
      ]
    };

    // OneLife
    var onelifeVariantID = selectedVariant.attr('data-365d-onelife-variant-id');
    var onelifeVariantSellingPlanID = selectedVariant.attr('data-365d-onelife-variant-selling-plan-id');

    formData.items.push({
      id: onelifeVariantID,
      quantity: 13,
      selling_plan: onelifeVariantSellingPlanID,
      properties : {
        '_BUNDLE' : 'comprehensive_365d',
        '_bundle_group_id' : 'comprehensive_365d_' + specialOfferVariantID,
        "_bundle_group_product" : true,
        "_bundle_group_product_row" : 2,
        "_bundle_group_product_multiplier" : 13,
        '_offer' : 'comprehensive_365d_' + specialOfferVariantID,
        '_offer_product_type' : 'primary',
      }
    });

    if (false && !bottleOOS) /*free gift off*/ {
      formData.items.push({
        id: 53491544391864, // Free bottle variant ID
        quantity: 2,
        properties : {
          '_offer' : 'comprehensive_365d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // 2026-05-21
    if (false && !frotherOOS) /*free gift off*/ {
      formData.items.push({
        id: 52887363551416, // Free frother variant ID
        quantity: 2,
        properties : {
          '_offer' : 'comprehensive_365d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // Disable button & show loading
    var originalText = $btn.text();
     $btn.text('Preparing your stack...').prop('disabled', true);

    

    // 1️⃣ Check cart first
          // 2️⃣ Add to cart
      /* Open the drawer NOW, not in the success callback. It renders the cart it
         already has, so it appears immediately and fills in when the add lands.
         Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
      if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function (addResponse) {
          setTimeout(function(){
            $btn.text(originalText).prop('disabled', false);
          }, 2000);

          // Always open the drawer to show the bundle (was: redirect to checkout when cart was empty)
          if (typeof FonCartDrawer !== 'undefined') {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer(addResponse);
          }
        },
        error: function () {
          resetButton();
          alert('Could not add item to cart. Please try again.');
        }
      });
    

    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }


  function checkout30d($btn, selectedVariant) {

    var specialOfferVariantID = selectedVariant.attr('data-30d-variant-id');
    var specialOfferVariantSellingPlanID = selectedVariant.attr('data-30d-variant-selling-plan-id');

    var formData = {
      items: [
        {
          id: specialOfferVariantID,
          quantity: 2,
          selling_plan: specialOfferVariantSellingPlanID,
          properties : {
            '_BUNDLE' : 'comprehensive_30d',
            '_bundle_group_id' : 'comprehensive_30d_' + specialOfferVariantID,
            "_bundle_group_product" : true,
            "_bundle_group_product_row" : 1,
            "_bundle_group_product_multiplier" : 2,
            '_offer' : 'comprehensive_30d_' + specialOfferVariantID,
            '_offer_product_type' : 'primary',
            '_order_from' : 'comprehensive-challenger'
          }
        }
      ]
    };

    // OneLife
    var onelifeVariantID = selectedVariant.attr('data-30d-onelife-variant-id');
    var onelifeVariantSellingPlanID = selectedVariant.attr('data-30d-onelife-variant-selling-plan-id');

    formData.items.push({
      id: onelifeVariantID,
      quantity: 1,
      selling_plan: onelifeVariantSellingPlanID,
      properties : {
        '_BUNDLE' : 'comprehensive_30d',
        '_bundle_group_id' : 'comprehensive_30d_' + specialOfferVariantID,
        "_bundle_group_product" : true,
        "_bundle_group_product_row" : 2,
        "_bundle_group_product_multiplier" : 1,
        '_offer' : 'comprehensive_30d_' + specialOfferVariantID,
        '_offer_product_type' : 'primary',
      }
    });

    if (false && !bottleOOS) /*free gift off*/ {
      formData.items.push({
        id: 53491544391864, // Free bottle variant ID
        quantity: 1,
        properties : {
          '_offer' : 'comprehensive_30d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // 2026-05-21
    if (false && !frotherOOS) /*free gift off*/ {
      formData.items.push({
        id: 52887363551416, // Free frother variant ID
        quantity: 1,
        properties : {
          '_offer' : 'comprehensive_30d_' + specialOfferVariantID,
          '_offer_product_type' : 'free',
        }
      });
    }

    // Disable button & show loading
    var originalText = $btn.text();
     $btn.text('Preparing your stack...').prop('disabled', true);


         // 1️⃣ Check cart first
          // 2️⃣ Add to cart
      /* Open the drawer NOW, not in the success callback. It renders the cart it
         already has, so it appears immediately and fills in when the add lands.
         Waiting for /cart/add.js meant ~800-1000ms of a dead-looking click. */
      if (typeof FonCartDrawer !== 'undefined') { FonCartDrawer.openCartDrawer(true); }

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: JSON.stringify(formData),
        dataType: 'json',
        contentType: 'application/json',
        success: function (addResponse) {
          setTimeout(function(){
            $btn.text(originalText).prop('disabled', false);
          }, 2000);

          // Always open the drawer to show the bundle (was: redirect to checkout when cart was empty)
          if (typeof FonCartDrawer !== 'undefined') {
            FonCartDrawer.openCartDrawer();
            FonCartDrawer.updateCartDrawer(addResponse);
          }
        },
        error: function () {
          resetButton();
          alert('Could not add item to cart. Please try again.');
        }
      });
    

    function resetButton() {
      $btn.text(originalText).prop('disabled', false);
    }
  }





  function checkPrices(){
    if ($('.fon-quantity-picker.active').length && $('.flavour-options > div.active').length){

      var selectedVariant = $('.flavour-options > div.active');
      var onetimePrice = selectedVariant.attr("data-one-time-price");
      var subscriptionPrice = selectedVariant.attr("data-subscription-price");

      onetimePrice = onetimePrice / 100;
      subscriptionPrice = subscriptionPrice / 100;
      

      var quantityElement = $('.fon-quantity-picker.active');
      var qty = parseInt(quantityElement.attr('data-qty'));





      

      switch (qty){
        case 1:

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

          

        break;
        case 2:
          
          onetimePrice = onetimePrice * qty * .95;
          subscriptionPrice = subscriptionPrice * qty * .95;

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


        break;

        case 3:
          
          onetimePrice = onetimePrice * qty * .90;
          subscriptionPrice = subscriptionPrice * qty * .90;

          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));


        break;


        case 4:

          onetimePrice = onetimePrice * qty * .85;
          subscriptionPrice = subscriptionPrice * qty * .85;
          
          $('div#fon-subscription-options .original-price').html(onetimePrice.toFixed(0));
          $('div#fon-subscription-options .sale-price').html(subscriptionPrice.toFixed(0));
          $('div#fon-onetime-option .sale-price').html(onetimePrice.toFixed(0));

        break;
      }

      var savePrice = onetimePrice - subscriptionPrice;
      $('save-price').html(savePrice.toFixed(0));

      var perServeValue = subscriptionPrice / (20 * qty);
      $('.per-serve').html('$'+perServeValue.toFixed(2));

      
    }
  }
  function checkVariantOption(){


    if ($('.fon-packaging.active').data('packaging') == 'onefit-sachets'){

      $('.dynamic-option-image').each(function(){
        $(this).attr('src',$(this).attr('data-packaging-sachets'));
      });

    }else{

      $('.dynamic-option-image').each(function(){
        $(this).attr('src',$(this).attr('data-packaging-pouch'));
      });

    }

    
    if ($('.flavour-options > div.active').length){


        // Restart dynamic values
        $("[data-dynamic-value]").removeClass('value-updated');


        var activeSelection = $('.flavour-options > div.active');

        

        var onetimePrice = activeSelection.attr("data-one-time-price");
        var subscriptionPrice = activeSelection.attr("data-subscription-price");

        var priceBasis = onetimePrice / 100;


        var activePaymentPlan = $('.fon-subscription-option.active').attr('data-payment-option');


        



         // Slide Down
        $('.fon-subscription-option').not('.active').find('.option-image').removeClass('open');

        if ($('.fon-subscription-option.active').find('.option-image').length){
          // $('.fon-subscription-option.active').find('.option-image').slideDown({
          //   duration: 600,
          //   easing: 'easeOutCubic'
          // });

          $('.fon-subscription-option.active')
          .find('.option-image')
          .addClass('open');

        }


        var selectedSKU = activeSelection.data('flavour-sku');


        var product90d = $('div[data-product="comprehensive-90-day-supply"] div[data-sku="' + selectedSKU + '"]');
        var product90dOneLife = $('div[data-product="comprehensive-90-day-supply"] div[data-sku="OL-WM-JAR-V2.5"]');

        if (product90d){
          
            var product90dPrice = parseFloat(product90d.data('price'));
            var product90dBilledPrice = product90dPrice * 5;
            var product90dPerDay = product90dBilledPrice / 90;
            var product90dMonthly = product90dBilledPrice / 3;




            activeSelection.attr('data-90d-variant-id',product90d.data('variant-id'));
            activeSelection.attr('data-90d-variant-selling-plan-id',product90d.data('selling-plan-id'));

            // OneLife
            activeSelection.attr('data-90d-onelife-variant-id',product90dOneLife.data('variant-id'));
            activeSelection.attr('data-90d-onelife-variant-selling-plan-id',product90dOneLife.data('selling-plan-id'));
            var product90dOneLifePrice = parseFloat(product90dOneLife.data('price'));
            var product90dOneLifePriceBilledPrice = product90dOneLifePrice * 3;


            // OneFit + OneLife
            product90dBilledPrice+=product90dOneLifePriceBilledPrice;
            product90dPerDay = product90dBilledPrice / 90;
            product90dMonthly = product90dBilledPrice / 3;


            $('[data-dynamic-value="90d-monthly"]').html(product90dMonthly.toFixed(0).toString().replace('.00','')+'/mo').addClass('value-updated');
            $('[data-dynamic-value="90d-billed-amount"]').html(product90dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="90d-per-day"]').html(product90dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }


        var product365d = $('div[data-product="comprehensive-365-day-supply"] div[data-sku="' + selectedSKU + '"]');
        var product365dOneLife = $('div[data-product="comprehensive-365-day-supply"] div[data-sku="OL-WM-JAR-V2.5"]');

        if (product365d){
            
            var product365dPrice = parseFloat(product365d.data('price'));
            var product365dBilledPrice = product365dPrice * 19;
            var product365dPerDay = product365dBilledPrice / 365;
            var product365dMonthly = product365dBilledPrice / 12;


            activeSelection.attr('data-365d-variant-id',product365d.data('variant-id'));
            activeSelection.attr('data-365d-variant-selling-plan-id',product365d.data('selling-plan-id'));

            // OneLife
            activeSelection.attr('data-365d-onelife-variant-id',product365dOneLife.data('variant-id'));
            activeSelection.attr('data-365d-onelife-variant-selling-plan-id',product365dOneLife.data('selling-plan-id'));
            var product365dOneLifePrice = parseFloat(product365dOneLife.data('price'));
            var product365dOneLifePriceBilledPrice = product365dOneLifePrice * 13;


            // OneFit + OneLife
            product365dBilledPrice+=product365dOneLifePriceBilledPrice;
            product365dPerDay = product365dBilledPrice / 365;
            product365dMonthly = product365dBilledPrice / 12;


            $('[data-dynamic-value="365d-monthly"]').html(product365dMonthly.toFixed(0).toString().replace('.00','')+'/mo').addClass('value-updated');
            $('[data-dynamic-value="365d-billed-amount"]').html(product365dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="365d-per-day"]').html(product365dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }



        var product30d = $('div[data-product="comprehensive-30-day-supply"] div[data-sku="' + selectedSKU + '"]');
        var product30dOneLife = $('div[data-product="comprehensive-30-day-supply"] div[data-sku="OL-WM-JAR-V2.5"]');

        if (product30d){
            
            var product30dPrice = parseFloat(product30d.data('price'));
            var product30dBilledPrice = product30dPrice * 2;
            var product30dPerDay = product30dBilledPrice / 30;
            var product30dMonthly = product30dBilledPrice / 1;


            activeSelection.attr('data-30d-variant-id',product30d.data('variant-id'));
            activeSelection.attr('data-30d-variant-selling-plan-id',product30d.data('selling-plan-id'));

            // OneLife
            activeSelection.attr('data-30d-onelife-variant-id',product30dOneLife.data('variant-id'));
            activeSelection.attr('data-30d-onelife-variant-selling-plan-id',product30dOneLife.data('selling-plan-id'));
            var product30dOneLifePrice = parseFloat(product30dOneLife.data('price'));
            var product30dOneLifePriceBilledPrice = product30dOneLifePrice * 1;


            // OneFit + OneLife
            product30dBilledPrice+=product30dOneLifePriceBilledPrice;
            product30dPerDay = product30dBilledPrice / 30;
            product30dMonthly = product30dBilledPrice / 1;


            $('[data-dynamic-value="30d-monthly"]').html(product30dMonthly.toFixed(0).toString().replace('.00','')+'/mo').addClass('value-updated');
            $('[data-dynamic-value="30d-billed-amount"]').html(product30dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
            $('[data-dynamic-value="30d-per-day"]').html(product30dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        }

        // var product60d = $('div[data-product="comprehensive-60-day-supply"] div[data-sku="' + selectedSKU + '"]');
        // var product60dOneLife = $('div[data-product="comprehensive-60-day-supply"] div[data-sku="OL-WM-JAR-V2.5"]');

        // if (product60d){
          

        //     var product60dPrice = parseFloat(product60d.data('price'));
        //     product60dPrice = product60dPrice.toString().replace('.00','');

        //     var product60dBilledPrice = product60dPrice * 3;
        //     var product60dPerDay = product60dBilledPrice / 60;
        //     var product60dMonthly = product60dBilledPrice / 2;

        //     activeSelection.attr('data-60d-variant-id',product60d.data('variant-id'));
        //     activeSelection.attr('data-60d-variant-selling-plan-id',product60d.data('selling-plan-id'));


        //     // OneLife
        //     activeSelection.attr('data-60d-onelife-variant-id',product60dOneLife.data('variant-id'));
        //     activeSelection.attr('data-60d-onelife-variant-selling-plan-id',product60dOneLife.data('selling-plan-id'));
        //     var product60dOneLifePrice = parseFloat(product60dOneLife.data('price').replace('.00',''));
        //     var product60dOneLifePriceBilledPrice = product60dOneLifePrice * 2;


        //     // OneFit + OneLife
        //     product60dBilledPrice+=product60dOneLifePriceBilledPrice;
        //     product60dPerDay = product60dBilledPrice / 60;
        //     product60dMonthly = product60dBilledPrice / 2;


        //     $('[data-dynamic-value="60d-monthly"]').html(product60dMonthly.toFixed(0).toString().replace('.00','')+'/mo').addClass('value-updated');
        //     $('[data-dynamic-value="60d-billed-amount"]').html(product60dBilledPrice.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        //     $('[data-dynamic-value="60d-per-day"]').html(product60dPerDay.toFixed(2).toString().replace('.00','')).addClass('value-updated');
        // }


        // One Time
        var oneTimeValue = onetimePrice / 100;


         // OneLife
        var oneLifeOneTime = parseFloat($('.comprehensive-onelife-pre-selected').data('variant-price'));
        oneTimeValue+=oneLifeOneTime;

        var oneTimeValuePerServing = oneTimeValue / 50;

       

        
        $('[data-dynamic-value="one-time"]').html(oneTimeValue + ' once').addClass('value-updated');
        $('[data-dynamic-value="one-time-per-day"]').html(oneTimeValuePerServing).addClass('value-updated');


       
        



    //   if (activePaymentPlan == 'subscription'){
    //     priceBasis = subscriptionPrice / 100;
    //   }
      

    //   var serveBasis = 20;

    //   if ($('.quantity-options-onelife').length){
    //     serveBasis = 30;
    //   }
      
    //   $(".fon-quantity-picker").each(function(index, element) {
    //     var qty = parseInt($(this).attr('data-qty'), 10);
    //     var perServeElement = $(this).find('.value');
    //     var perServeValue = 0;


    //     switch (qty){
    //       case 1:
    //         perServeValue = priceBasis / serveBasis;
    //       break;
    //       case 2:
    //         perServeValue = (priceBasis * qty * 0.95) / (serveBasis * qty);
    //       break;
    //       case 3:
    //         perServeValue = (priceBasis * qty * 0.90) / (serveBasis * qty);
    //       break;
    //       case 4:
    //         perServeValue = (priceBasis * qty * 0.85) / (serveBasis * qty);
    //       break;
    //     }

    //     perServeElement.html(perServeValue.toFixed(2));
        
    //   });

      updateImage();

    }

  }


  $(document).on('click', '.fon-accordion-heading', function () {
    // Remove active from all others
    $('.fon-accordion-heading').not(this).removeClass('active');

    // Toggle only the clicked one
    $(this).toggleClass('active');

    // Smooth scroll to the clicked heading
    $('html, body').animate({
      scrollTop: $(this).offset().top - 100 // adjust offset for sticky headers, etc.
    }, 400); // 400ms = smooth animation duration
  });


  initNearView(document.querySelector('.reviews-swiper'), function () {
  var swiper = new Swiper(".reviews-swiper", {
    slidesPerView: 1, // default for desktop
    spaceBetween: 20,
    grabCursor: true,
    loop: true,
    centeredSlides: true, // turned off grid-style center mode
    breakpoints: {
      // when window width is <= 768px (tablet & below)
      768: {
        slidesPerView: 3
      }
    }
  });
  });

  initNearView(document.querySelector('.swiper-of-all-hall'), function () {
  var swiperHallOfFame = new Swiper(".swiper-of-all-hall", {
    slidesPerView: 1.2,
    spaceBetween: 42,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 42
      }
    }
  });
  });
  initNearView(document.querySelector('.swiper-of-all-hall-mobile'), function () {
  var swiperHallOfFame = new Swiper(".swiper-of-all-hall-mobile", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    }
  });
  });



  $('.open-supplement-facts').magnificPopup({
    type: 'inline',
    // callbacks: {
    //       open: function() {
    //           console.log('Popup body-inline-bottom');
    //           $('body').addClass('body-popup-slide');
    //       },
    //       close: function() {
    //           console.log('Popup closed');
    //           $('body').removeClass('body-popup-slide');
    //       }
    // },
    // mainClass: 'mfp-animate-bottom',
    // closeMarkup: `
    //   <button title="%title%" type="button" class="mfp-close">
    //     <svg role="presentation" stroke-width="2" focusable="false" width="24" height="24" class="icon icon-close" viewBox="0 0 24 24">
    //       <path d="M17.658 6.343 6.344 17.657M17.658 17.657 6.344 6.343" stroke="currentColor"></path>
    //     </svg>
    //   </button>
    // `
  });


  // Supplement Facts
  $(document).on("click", ".flavour-options-facts > div", function() {
    // remove active from siblings, add to clicked one
    $(this).addClass("active").siblings().removeClass("active");

    // check if clicked has .flavour-vegan
    if ($(this).hasClass("flavour-vegan")) {
      $(".protein-type").text("Pea Protein");
    } else {
      $(".protein-type").text("Organic Collagen Peptides");
    }
  });


  

  // Helper: check if color is light
  function isLightColor(hex) {
    if (!hex) return false;
    hex = hex.replace("#", "");

    // Expand shorthand (e.g. "fff" → "ffffff")
    if (hex.length === 3) {
      hex = hex.split("").map(c => c + c).join("");
    }

    var r = parseInt(hex.substr(0, 2), 16);
    var g = parseInt(hex.substr(2, 2), 16);
    var b = parseInt(hex.substr(4, 2), 16);

    // Perceived brightness (HSP)
    var brightness = Math.sqrt(
      0.299 * (r * r) +
      0.587 * (g * g) +
      0.114 * (b * b)
    );

    return brightness > 200; // threshold, tweak if needed
  }



  function initGallery($gallery) {
  $gallery.on('click', 'img, video', function (e) {
    e.preventDefault();

    var $clicked = $(this);
    var $items = $gallery.find('img, video');

    var promises = $items.map(function () {
      var $el = $(this);

      // VIDEO ITEM
      if ($el.is('video')) {
        return Promise.resolve({
          html:
            '<div style="display:flex;justify-content:center;align-items:center;width:100%;height:100%;">' +
              '<video autoplay muted loop playsinline preload="auto" ' +
              'style="max-width:100%;max-height:100%;width:auto;height:auto;">' +
                '<source src="' + $el.find('source').attr('src') + '" type="video/mp4">' +
                'Your browser does not support the video tag.' +
              '</video>' +
            '</div>',
          w: 1920,
          h: 1080
        });
      }

      // IMAGE ITEM (get original size)
      // <picture> carries no src — only its inner <img> does. Without this fallback
      // imgSrc is undefined, the browser requests /products/undefined (404), img.onload
      // never fires, Promise.all never settles and the lightbox never opens.
      var imgSrc = $el.data('large') || $el.attr('src') || $el.find('img').attr('src');
      return new Promise(function (resolve) {
        var img = new Image();
        img.onload = function () {
          resolve({
            src: imgSrc,
            w: img.naturalWidth,
            h: img.naturalHeight
          });
        };
        img.src = imgSrc;
      });
    }).get();

    Promise.all(promises).then(function (items) {
      var index = $items.index($clicked);
      var pswpElement = document.querySelector('.pswp');

      var options = {
        index: index,
        bgOpacity: 0.9,
        showHideOpacity: true,
        barsSize: { top:44, bottom:'auto' }, // space for top bar
        shareEl: false,                       // hide share if not needed
        fullscreenEl: false,                  // hide fullscreen if not needed
        zoomEl: false,                        // hide zoom if not needed
        counterEl: false,                     // hide counter if not needed
        arrowEl: true,                        // keep prev/next arrows
        closeEl: true,                        // ✅ show close button
        closeElClasses: ['item', 'caption', 'zoom-wrap', 'ui', 'top-bar'] // where it should render
      };

      var lightbox = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
      lightbox.init();
    });
  });
}


  // Desktop gallery
  initGallery($('.product-main-gallery'));

  initNearView(document.querySelector('.onefit-all-marquee-swiper'), function () {
  const marqueeSwiper = new Swiper(".onefit-all-marquee-swiper", {
    slidesPerView: "auto",   // size slides to content
    spaceBetween: 30,        // spacing between
    loop: true,              // seamless repeat
    allowTouchMove: false,   // disable dragging
    speed: 10000,            // how long 1 loop takes (ms) → higher = slower
    autoplay: {
      delay: 0,              // no pause, continuous
      disableOnInteraction: false,
    },
  });
  pauseOffscreen(document.querySelector('.onefit-all-marquee-swiper'), marqueeSwiper);
  });

  // $('.fon-flavour-oos').on('click', function () {
  //   let $el = $(this);
  //   $el.addClass('wiggle');
    
  //   // remove after animation ends so it can trigger again
  //   setTimeout(() => {
  //     $el.removeClass('wiggle');
  //   }, 500); // match animation duration
  // });


  // All videos
  const videos = document.querySelectorAll('.onefit-all-videos video');

  // Intersection Observer to trigger play when visible
  let observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const video = entry.target;

      if (entry.isIntersecting) {
        // Try autoplay unmuted
        video.muted = true;
        video.loop = true;
        video.play().catch(err => {
          console.log("Autoplay blocked:", err);
        });

        $('.onefit-all-videos img').fadeOut();
        $('.onefit-all-videos video-media').attr('loaded','true');

      } else {
        video.pause(); // optional: pause when out of view
      }
    });
  }, {
    threshold: 0.1 // at least 50% visible
  });

  videos.forEach(video => observer.observe(video));

  $('.onefit-all-videos .video-container').on('click', function () {
    const $container = $(this);
    const $video = $container.find('video').get(0);
    const $overlay = $container.find('.video-overlay');

    if ($video.muted) {
      // Mute all others and reset overlays
      $('.onefit-all-videos .video-container').each(function () {
        const v = $(this).find('video').get(0);
        v.muted = true;
        $(this).find('.video-overlay').show();
      });

      // Unmute clicked video + hide overlay
      $video.muted = false;
      $overlay.hide();

      if ($video.paused) {
        $video.play().catch(() => {});
      }
    } else {
      // Already unmuted → mute and show overlay
      $video.muted = true;
      $overlay.show();
    }
  });

  // const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
  //   effect: 'fade',
  //   fadeEffect: {
  //     crossFade: true, // keep enabled for soft transition
  //   },
  //   loop: true,
  //   speed: 700, // shorter fade duration
  //   autoplay: {
  //     delay: 2000, // longer time before next transition
  //     disableOnInteraction: false,
  //   },
  // });

initNearView(document.querySelector('.swiper-add-to-cart-carousel'), function () {
const addToCartSwiper = new Swiper('.swiper-add-to-cart-carousel', {
  slidesPerView: 'auto',
  spaceBetween: 0,
  loop: true,
  freeMode: true,
  freeModeMomentum: false,
  allowTouchMove: false,
  speed: 6000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});
pauseOffscreen(document.querySelector('.swiper-add-to-cart-carousel'), addToCartSwiper);
});


  const $section = $('#section-whats-inside');

  $('.of-inside-container').each(function () {
  const $container = $(this);

  if (!$container.length) return;

  // Duplicate content ONCE per container
  $container.append($container.html());

  let speed = 40; // pixels per second
  let paused = false;
  let currentScroll = 0;
  let lastTime = 0;

  // Optional hover pause
  // $container.on('mouseenter', () => paused = true);
  // $container.on('mouseleave', () => paused = false);

  var running = false;
  function infiniteScroll(timestamp) {
    if (!lastTime) lastTime = timestamp;

    const delta = (timestamp - lastTime) / 1000;
    lastTime = timestamp;

    if (!paused) {
      currentScroll += speed * delta;

      const halfHeight = $container[0].scrollHeight / 2;

      if (currentScroll >= halfHeight) {
        currentScroll -= halfHeight;
      }

      $container[0].scrollTop = currentScroll;
    }

    if (running) requestAnimationFrame(infiniteScroll);
  }

  // Run the marquee only while it is on screen: the rAF loop otherwise burns
  // main-thread time for the whole page lifetime (shows as large TBT in traces).
  if ('IntersectionObserver' in window) {
    var marqueeVis = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        if (!running) { running = true; lastTime = 0; requestAnimationFrame(infiniteScroll); }
      } else {
        running = false;
      }
    }, { rootMargin: '100px 0px' });
    marqueeVis.observe($container[0]);
  } else {
    running = true;
    requestAnimationFrame(infiniteScroll);
  }
});
  // const $container = $section.find('.of-inside-container');

  // if (!$container.length) return;

  // // Duplicate content ONCE
  // $container.append($container.html());

  // let speed = 40; // pixels per second (instead of 0.25 per frame)
  // let paused = false;
  // let currentScroll = 0;
  // let lastTime = 0;

  // // Optional hover pause
  // // $container.on('mouseenter', () => paused = true);
  // // $container.on('mouseleave', () => paused = false);

  // function infiniteScroll(timestamp) {
  //   if (!lastTime) lastTime = timestamp;

  //   const delta = (timestamp - lastTime) / 1000; // seconds since last frame
  //   lastTime = timestamp;

  //   if (!paused) {
  //     currentScroll += speed * delta;

  //     const halfHeight = $container[0].scrollHeight / 2;

  //     if (currentScroll >= halfHeight) {
  //       currentScroll -= halfHeight; // seamless reset
  //     }

  //     $container[0].scrollTop = currentScroll; // removed Math.floor()
  //   }

  //   requestAnimationFrame(infiniteScroll);
  // }

  // requestAnimationFrame(infiniteScroll);


  // const $section = $('#section-whats-inside');
  // const $container = $section.find('.of-inside-container');

  // if (!$container.length) return;

  // // Duplicate content ONCE
  // $container.append($container.html());

  // let speed = 0.25;          // visual speed
  // let paused = false;
  // let currentScroll = 0;    // float accumulator

  // // $container.on('mouseenter', () => paused = true);
  // // $container.on('mouseleave', () => paused = false);

  // function infiniteScroll() {
  //   if (!paused) {
  //     currentScroll += speed;

  //     const halfHeight = $container[0].scrollHeight / 2;

  //     if (currentScroll >= halfHeight) {
  //       currentScroll -= halfHeight; // seamless reset
  //     }

  //     $container.scrollTop(Math.floor(currentScroll));
  //   }

  //   requestAnimationFrame(infiniteScroll);
  // }

  // infiniteScroll();


  const storeStatuses = document.querySelectorAll('.store-status');

    storeStatuses.forEach(el => {
      const rand = Math.random();

      if (rand < 0.60) {
        // 85%
        el.textContent = 'IN STOCK';
        el.classList.add('in-stock');
        el.classList.remove('low-stock', 'out-of-stock');

      } else if (rand < 0.90) {
        // 10%
        el.textContent = 'LOW STOCK';
        el.classList.add('low-stock');
        el.classList.remove('in-stock', 'out-of-stock');

      } else {
        // 5%
        el.textContent = 'OUT OF STOCK';
        el.classList.add('out-of-stock');
        el.classList.remove('in-stock', 'low-stock');
      }
    });


    function showOutOfStockPopup(variantID){
      $.magnificPopup.open({
        items: {
          src: '#klaviyo-oos-' + variantID // This is the ID of the hidden div
        },
        type: 'inline'
      });
    }


    $('a[href="#packaging-options"]').on('click', function(e) {
      
      $('#fon-subscription-90d-options').trigger('click');
    });

    // March 31, 2026 OneLife OOS
    if (productOOS){
      showOutOfStockPopup(52881590223032);
      $('#fon-oos-button').show().addClass('mt-0 mb-3');
      $('#fon-checkout-button').hide();
    }
    

  

});
